import { EntityTypeOld, ErrorStateOld } from "Store/interfaces/products";

import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import { PostalAddressDto } from "Store/interfaces/PostalAddressDto";

export interface UserIdentificationData {
  readonly nin?: string;
  readonly discountResponse: DiscountResponse;
  readonly customerInfoResponse: CustomerInfoResponse;
  readonly newCartResponse: NewCartResponse;
  readonly newCustomerResponse: NewCustomerResponse;
}

// Backend API response
export enum CustomerStatus {
  NOT_OK = "NOT_OK",
  CUSTOMER_EXISTING = "CUSTOMER_EXISTING",
  CUSTOMER_NEW = "CUSTOMER_NEW",
  CUSTOMER_TOO_YOUNG = "CUSTOMER_TOO_YOUNG",
}

export interface DiscountResponse {
  readonly f2100: {
    readonly isNewInsuranceCustomer: boolean;
    readonly hasBasisProduct?: boolean;
    readonly paymentPeriod: string;
    readonly agreementProduct: number;
  };
  readonly isFfa?: boolean;
  readonly customerStatus?: CustomerStatus;
}

// Backend API response
export interface CustomerInfoResponse {
  readonly properties: {
    readonly agreementProduct: number;
    readonly customerStatus: string;
  };
  readonly _links: {
    readonly customer: [
      {
        readonly href: string;
      },
    ];
    readonly self: {
      readonly href: string;
    };
  };
}

// Backend API response
export interface NewCartResponse {
  readonly cartId: string;
  readonly isCartInitializedByAdvisor: boolean;
  readonly isCartUpdatedWithNewPrice: boolean;
  readonly orderId?: string;
  readonly timestamp: {
    readonly created: string;
  };
  readonly _links: {
    readonly customer: [
      {
        readonly href: string;
      },
    ];
    readonly self: {
      readonly href: string;
    };
  };
}

// Backend API response
export interface NewCustomerResponse {
  readonly age: string;
  readonly dateOfBirth?: string;
  readonly isFemale: boolean;
  readonly campaignCode?: string;
  readonly cmId: string;
  readonly cmOrganizationId?: string;
  readonly customerRef: string;
  readonly isValid: boolean;
  readonly manualAgreementProduct?: number;
  readonly providedPersonInfo: {
    readonly name?: {
      readonly firstName?: string;
      readonly lastName?: string;
    };
    readonly nin?: string;
  };
  readonly providedContactInfo?: {
    readonly address?: PostalAddressDto;
  };
  readonly properties: {
    readonly "no.storebrand.orders.f2100.processors.F2100PropertiesProcessor": {
      readonly isNewInsuranceCustomerFromDiscount: boolean;
      readonly paymentPeriod: string;
      readonly agreementProductFromDiscount: number;
    };
  };
}

export type UserIdentificationEntity = EntityTypeOld<
  UserIdentificationData,
  OperationType
>;

export type UserIdentificationError = ErrorStateOld<OperationType>;

export enum OperationType {
  GET_DISCOUNT_REQUEST = "GET_DISCOUNT_REQUEST",
  CREATE_NEW_CART_REQUEST = "CREATE_NEW_CART_REQUEST",
  UPDATE_CUSTOMER_INFO_REQUEST = "UPDATE_CUSTOMER_INFO_REQUEST",
  CREATE_NEW_CUSTOMER_REQUEST = "CREATE_NEW_CUSTOMER_REQUEST",
  GET_CART_REQUEST = "GET_CART_REQUEST",
  GET_OFFER_FROM_ADVISOR_REQUEST = "GET_OFFER_FROM_ADVISOR_REQUEST",
  GET_CUSTOMER_REQUEST = "GET_CUSTOMER_REQUEST",
  USER_IDENTIFICATION = "USER_IDENTIFICATION",
  USER_IDENTIFICATION_V2 = "USER_IDENTIFICATION_V2",
  USER_IDENTIFICATION_EXISTING_CART = "USER_IDENTIFICATION_EXISTING_CART",
  GET_AKA_HEALTH_CONFIG = "GET_AKA_HEALTH_CONFIG",
}

export interface ApiRequest {
  type: OperationType;
  payload: any;
}

export interface UserIdentificationPayload {
  ssn?: string;
  firstName?: string;
  lastName?: string;
  products: ProductBackendName;
}

export interface UserIdentificationV2Payload {
  customerRef: string;
}

export interface UserIdentificationExistingCartPayload {
  readonly cartId: string;
  readonly cartIdFromCookie: boolean;
}

export interface UserIdentificationMaybeExistingCartPayload {
  readonly cartId: string;
  readonly products: ProductBackendName;
  readonly cartIdFromCookie: boolean;
}
